import * as _ from 'lodash';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import { CreditRequirements } from '../../../../../../ng2/shared/constants/credit-requirements.constant';
import { GapPlanStatuses } from '../../../../../../ng2/shared/constants/gap-plan-statuses.constant';
import { ImGapPlan } from '../../../../../../ng2/shared/services/im-models/im-gap-plan';

angular.module('nv.singleStudent').controller('StudentCreditGapsPanelGapPlansCtrl', studentCreditGapsPanelGapPlansCtrl);

function studentCreditGapsPanelGapPlansCtrl(
  CreditGapModal,
  ErrorModal,
  UtilitiesService,
  $scope,
  Rollbar,
  ImSchool: ImSchool,
  ImGapPlan: ImGapPlan,
) {
  class CreditGapsPanelGapPlans {
    school;
    student;
    studentGapPlans;
    schoolCurrentTermYear;
    allIncludedGapPlans;

    constructor(school, student, studentGapPlans) {
      this.school = school;
      this.student = student;
      this.studentGapPlans = studentGapPlans;
      this.schoolCurrentTermYear = ImSchool.getCurrentTermYear(this.school);
      this.allIncludedGapPlans = this.getGapPlansForPanel(this.studentGapPlans);
    }

    // TODO: Use IGapPlan interface here once this is a typescript file
    getGapPlansForPanel(studentGapPlans) {
      let allIncludedGapPlans = [];

      _.reduce(
        studentGapPlans,
        (allIncludedGapPlans, gapPlan) => {
          const gapPlanIsNotDeleted = this.isGapPlanNotDeleted(gapPlan);

          if (gapPlanIsNotDeleted) {
            const gapPlanForPanel = this.getGapPlanForPanel(gapPlan);
            allIncludedGapPlans.push(gapPlanForPanel);
          }

          return allIncludedGapPlans;
        },
        allIncludedGapPlans,
      );

      const allIncludedGapPlansSortedByTerm = _.sortBy(allIncludedGapPlans, ['termCode']);

      return allIncludedGapPlansSortedByTerm;
    }

    getGapPlanForPanel(gapPlan) {
      const { gradReq, termYear } = gapPlan;
      const frontEndStatus = this.getGapPlanFrontendStatus(gapPlan);
      const isAppliedOrInPast =
        frontEndStatus === GapPlanStatuses.frontend.APPLIED || frontEndStatus === GapPlanStatuses.frontend.PAST;
      const gapPlanForPanel = {
        // TODO: Add interface for this object when this file is changed to typescript
        _id: gapPlan._id,
        plan: gapPlan.plan,
        gradReqHuman: this.convertGradReqToHuman(gradReq),
        termCode: gapPlan.termYear,
        termCodeHuman: this.convertTermCodeToHuman(termYear),
        frontEndStatus,
        isAppliedOrInPast,
        creditValue: gapPlan.creditValue,
      };

      return gapPlanForPanel;
    }

    updateGapPlansForPanel(studentGapPlans) {
      this.allIncludedGapPlans = this.getGapPlansForPanel(studentGapPlans);
    }

    isGapPlanNotDeleted(gapPlan) {
      return !ImGapPlan.isDeleted(gapPlan);
    }

    getGapPlanFrontendStatus(gapPlan) {
      return ImGapPlan.getFrontendStatus(gapPlan, this.schoolCurrentTermYear);
    }

    openEditableGapPlanModal(gapPlanId) {
      // const updatedGapPlan = _.find(this.studentGapPlans, { _id: gapPlanId });
      // const updatedGapPlanIndex = _.findIndex(this.studentGapPlans, updatedGapPlan);
      const promise = CreditGapModal.show(this.school._id, this.student._id, gapPlanId);
      promise
        .then(result => {
          if (result && result.action === 'UPDATE_GAP_PLAN') {
            const updatedGapPlan = result.gapPlan;
            const studentGapPlanToUpdateIndex = _.findIndex(this.studentGapPlans, { _id: gapPlanId });
            this.studentGapPlans[studentGapPlanToUpdateIndex] = updatedGapPlan;
            this.updateGapPlansForPanel(this.studentGapPlans);
          }
        })
        .catch(err => {
          Rollbar.error(`Unable to update student gap plans panel`, err);
        });
    }

    convertTermCodeToHuman(termCode) {
      if (termCode === 999) {
        return 'N/A';
      }
      return UtilitiesService.getHumanReadableTerm(termCode);
    }

    convertGradReqToHuman(gradReq) {
      return gradReq !== null ? _.find(CreditRequirements, { camelCase: gradReq }).human : 'None';
    }

    dropGapPlan(gapPlan) {
      const index = _.findIndex(this.studentGapPlans, { _id: gapPlan._id });
      const studentGapPlanToDrop = this.studentGapPlans[index];

      studentGapPlanToDrop.status = gapPlan.status = GapPlanStatuses.backend.DELETED;
      studentGapPlanToDrop.$patchFields(
        ['status'],
        () => {
          _.pullAt(this.studentGapPlans, index);
          this.updateGapPlansForPanel(this.studentGapPlans);
        },
        function(error) {
          ErrorModal.show('Error dropping gap plan', error);
        },
      );
    }

    openMenu($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    }
  }

  $scope.$watch(
    () => {
      return this.studentGapPlans;
    },
    () => {
      this.gapPlans = new CreditGapsPanelGapPlans(this.school, this.student, this.studentGapPlans);
    },
    true,
  );
}
